<template>
  <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 max-w-xl min-w-full sm:min-w-30 mx-auto">
    <form @submit="sendForgotEmail">
      <Heading class="mb-16" center>Forgot Password?</Heading>
      <div class="mb-12 mt-4">
        <label for="email" class="text-sm">Email<small>*</small></label>
        <input type="email" class="input mt-2" id="email" v-model="email" />
        <transition name="fade">
						<span class="text-canceled block text-xs mt-2 pl-2" v-if="isError">
							{{ errors.email ? errors.email[0] : 'Something went wrong. Please, try again later' }}
						</span>
        </transition>
      </div>
      <button
        type="submit"
        class="btn w-full btn-primary rounded-lg font-semibold sm:px-12"
        :disabled="!canSubmit || loading"
      >
        <span v-if="!loading">Save</span>
        <Spinner class="mx-auto" v-if="loading" />
      </button>
    </form>
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  import { required, email } from "vuelidate/lib/validators"
  import api from "@/api"
  import { Utils } from "@/utils"
  import Spinner from "@/components/common/Spinner"
  import Heading from "@/components/common/Heading"

  export default {
    name: "ForgotPassword",
    components: {
      Spinner,
      Heading
    },
    data() {
      return {
        email: '',
        loading: false,
        errors: {},
      }
    },
    validations: {
      email: {
        required,
        email
      }
    },
    computed: {
      canSubmit() {
        return !this.$v.$invalid
      },
      isError() {
        return !Utils.isObjectEmpty(this.errors)
      }
    },
    methods: {
      async sendForgotEmail(event) {
        event.preventDefault()
        this.loading = true
        this.errors = {}

        try {
          await api.forgotPassword({ email: this.email })
          this.loading = false
          this.$emit('success')
        } catch (error) {
          this.errors = error.errors ? error.errors : error
          this.loading = false
        }
      }
    }
  }
</script>